const normalizeText = (value = "") =>
  String(value).toLowerCase().replace(/\s+/g, " ").trim();

const getSpamSignals = (text = "") => {
  const normalized = normalizeText(text);

  const spamPhrases = [
    "scam",
    "fraud",
    "fake",
    "worst ever",
    "best ever",
    "do not rent",
    "stay away",
    "warning",
    "lawsuit",
    "criminal",
  ];

  let hits = 0;
  spamPhrases.forEach((phrase) => {
    if (normalized.includes(phrase)) hits += 1;
  });

  return hits;
};

export function getReviewRiskScore({
  reviewText = "",
  rating = 5,
  reviewerAccountAgeDays = 0,
  reviewerVerified = false,
  priorReviewCount = 0,
}) {
  let score = 0;
  const reasons = [];

  const text = normalizeText(reviewText);
  const spamHits = getSpamSignals(text);

  if (!text || text.length < 12) {
    score += 18;
    reasons.push("Review text is very short");
  }

  if (text.length > 0 && text.length < 25) {
    score += 8;
    reasons.push("Review is low detail");
  }

  if (spamHits >= 2) {
    score += 20;
    reasons.push("Review contains multiple aggressive or suspicious phrases");
  } else if (spamHits === 1) {
    score += 8;
    reasons.push("Review contains a risky phrase");
  }

  if (Number(rating) === 1 || Number(rating) === 5) {
    score += 6;
    reasons.push("Extreme rating");
  }

  if (reviewerAccountAgeDays <= 3) {
    score += 18;
    reasons.push("Very new account");
  } else if (reviewerAccountAgeDays <= 14) {
    score += 10;
    reasons.push("New account");
  }

  if (!reviewerVerified) {
    score += 10;
    reasons.push("Reviewer is not verified");
  } else {
    score -= 8;
  }

  if (priorReviewCount >= 15) {
    score += 10;
    reasons.push("High review volume from this reviewer");
  } else if (priorReviewCount >= 5) {
    score += 4;
  }

  score = Math.max(0, Math.min(100, score));

  let label = "low";
  if (score >= 70) label = "high";
  else if (score >= 35) label = "medium";

  return {
    score,
    label,
    reasons,
  };
}

export function getUserTrustScore({
  verified = false,
  reviewCount = 0,
  averageRating = 0,
  reportsCount = 0,
  accountAgeDays = 0,
}) {
  let score = 50;

  if (verified) score += 20;
  if (reviewCount >= 10) score += 10;
  else if (reviewCount >= 3) score += 5;

  if (averageRating >= 4.5) score += 8;
  else if (averageRating >= 4.0) score += 5;
  else if (averageRating <= 2.5 && reviewCount > 0) score -= 10;

  if (reportsCount >= 3) score -= 20;
  else if (reportsCount >= 1) score -= 8;

  if (accountAgeDays >= 180) score += 8;
  else if (accountAgeDays >= 30) score += 4;
  else if (accountAgeDays <= 7) score -= 6;

  return Math.max(0, Math.min(100, score));
}

export function getTrustBadge(score = 0) {
  if (score >= 85) return "Elite";
  if (score >= 70) return "Trusted";
  if (score >= 50) return "Solid";
  if (score >= 30) return "Watch";
  return "High Risk";
}

const aiTrust = {
  getReviewRiskScore,
  getUserTrustScore,
  getTrustBadge,
};

export default aiTrust;